import colors from "../themes/colors";
import { dt } from "../themes/redesignTokens";

const socialLinkIconStyles = (color: string) => {
  const stylesIcon = {
    height: 24,
    width: 24,
    color: color,
    "&:hover": {
      color: color === colors.secondary.gray80 ?  "" : dt.blue
    }
  };

  return stylesIcon;
};

export default socialLinkIconStyles;
